import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPinterestP } from '@fortawesome/free-brands-svg-icons';
import cn from 'clsx';

function ButtonPinterest({ onClick }) {
  const btnClassName = cn('btn btn-sm', 'btn-pinterest');

  return (
    <button type="button" className={btnClassName} onClick={onClick}>
      <FontAwesomeIcon icon={faPinterestP} className="icon-pinterest" />
      <span>Pin it</span>
      <style jsx global>
        {`
          .btn-pinterest {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            padding: 4px 8px;
            min-width: 100px;
            width: 100%;
            color: white;
            font-weight: 500;
            font-size: 15px;
            background: #cb2027;
            border: none;
            border-radius: 2px;
          }
          .btn-pinterest.btn:hover,
          .btn-pinterest.btn:focus {
            color: white;
            opacity: 0.9;
          }

          .icon-pinterest {
            width: 12px;
            margin-right: 4px;
          }
        `}
      </style>
    </button>
  );
}

export default ButtonPinterest;
